import { d } from './chunk-4HOEKH6K.js';

var i;(m=>{async function n(o,t){return d.getCameras(o!=null?o:!1,t!=null?t:!1)}m.getCameras=n;})(i||(i={}));

export { i as a };
